import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import MetaData from '../layouts/MetaData';
import { clearAuthError, login } from '../../actions/userActions';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const redirect = '/dashboard';
  const { loading, error, isAuthenticated } = useSelector(state => state.authState);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirect);
    }
    if (error) {
      toast(error, {
        type: 'error',
        onOpen: () => {
          dispatch(clearAuthError);
        },
      });
      return;
    }
  }, [error, isAuthenticated, dispatch, navigate, redirect]);

  return (
    <>
      <MetaData title="Login" />
      <div className="login-page">
        <div className="login-card">
          {/* Card top - brand logo */}
          <div className="login-card-top" style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '2rem 2rem 1rem' }}>
            <img 
              src="/images/logo-light.jpg" 
              alt="Green Naturopathy" 
              style={{ width: '200px', maxWidth: '100%', height: 'auto', marginBottom: '1rem' }} 
            />
            <h2 style={{ color: '#0f172a' }}>Welcome Back</h2>
            <p style={{ color: '#64748b' }}>Sign in to your dashboard</p>
          </div>

          {/* Card body - form */}
          <div className="login-card-body">
            <form onSubmit={submitHandler}>
              <div className="mb-3">
                <label className="form-label" htmlFor="email_field">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email_field"
                  className="form-control"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="password_field">
                  Password
                </label>
                <input
                  type="password"
                  id="password_field"
                  className="form-control"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>

              <button
                id="login_button"
                type="submit"
                className="btn-login"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Signing in...
                  </>
                ) : (
                  <>
                    <i className="fa fa-sign-in-alt me-2"></i>
                    Sign In
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
